// List other product IDs to promote for each app, in the desired order.
// Empty or missing entries use catalogDefaults.order; unlisted products follow it.
export const productAffinities = Object.freeze({
  user: Object.freeze([]),
  surfer: Object.freeze([]),
  signitic: Object.freeze(['user', 'iconosquare', 'nocrm']),
  iconosquare: Object.freeze(['signitic']),
  humanlinker: Object.freeze(['nocrm', 'ubic']),
  nocrm: Object.freeze(['humanlinker', 'ubic']),
  ubic: Object.freeze(['nocrm', 'humanlinker']),
});
